import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable, tap} from 'rxjs';
import {environment} from '@flw-env';

@Injectable({
  providedIn: 'root'
})
export class GraphService {
  private http = inject(HttpClient);

  public getProfile(): Observable<any> {
    // select only what you need
    return this.http.get<any>(
      `${environment.apiConfig.uri}?$select=givenName,surname`
    ).pipe(
      map(res => {
       return  `${res.givenName} ${res.surname}`|| ''
      }),
    );
  }

  public getPhoto(): Observable<string> {
    // returns the binary JPEG/PNG
    return this.http.get(`${environment.apiConfig.uri}/photo/$value`, {responseType: 'blob'}).pipe(
      map(img => URL.createObjectURL(img))
    );
  }
}
